// Dependencies.
import styled from 'styled-components'

// Modal Content.
export const ModalContentWrapper = styled.div`
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.1);
  height: 470px;
  margin: auto;
  margin-top: 20vmin;
  min-height: 470px;
  max-width: 90%;
  overflow-x: hidden;
  pointer-events: auto;
  width: 600px;
`
